import { SaveButton, useNotify, useRefresh } from "react-admin";
import { useFormContext } from "react-hook-form";
import useConflictErrorModal from "server/components/Modals/useConflictErrorModal";
import dataProvider from "server/dataProvider";
import { graduationRequests } from "api/graduationApi";
import { useNotifyError } from "utils/useNotifyError";

const SaveButtonProfessors = ({ record, setIsProfessorEditing }) => {
  const { getValues } = useFormContext(); // <-- работи защото е дете на SimpleForm
  const { handleConflictError, ConflictErrorDialog } = useConflictErrorModal();
  const notifyError = useNotifyError();
  const notify = useNotify();
  const refresh = useRefresh();

  const handleSubmit = async () => {
    const formDataToSave = getValues();
    const flatCommissions = formDataToSave.commissions.flatMap((commission, index) =>
      (commission.professors || []).map(professor => ({
        employeeId: professor.employeeId,
        role: professor.role,
        commissionNumber: commission.commissionNumber || index + 1,
      })),
    );

    const payload = { commissions: flatCommissions };

    try {
      await dataProvider.customRequest(graduationRequests.updateStateExamCommission(record?.id), payload, "PUT");
      refresh();
      notify("Записът е редактиран", { type: "success" });
      setIsProfessorEditing(false);
    } catch (err) {
      notifyError(err);
      handleConflictError(err);
    }
  };

  return (
    <>
      <SaveButton
        label="Запази"
        size="small"
        onClick={handleSubmit}
      />
      <ConflictErrorDialog />
    </>
  );
};

export default SaveButtonProfessors;
